/* eslint-disable prettier/prettier */
import { Check, CheckCircle, Siren } from "@phosphor-icons/react";
import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  BoxText,
  ButtonContainer,
  CheckboxAppearence,
  CheckboxContainer,
  CheckboxInput,
  Container,
  FiltersContainer,
  LabelBullet,
  Labels,
  LabelsContainer,
  Row,
  StatusBox,
  Table,
  TableCell,
  TableCellEmpty,
  TableHeader,
  Title,
} from "./styles";

import PrevixIcon from "../../assets/images/Surveillance/iconPrevix.svg";
import { Modal } from "../../components/Modal";
import { SideTab } from "../../components/SideTab";
import { TitleLine } from "../../components/TitleLine";
import { Button } from "../../components/common/Button";
import { DefaultContent } from "../../components/common/DefaultContent";
import { Input } from "../../components/common/Input";
import { Select } from "../../components/common/Select";
import { ContextLatestRequests } from "../../context/context_latestRequests";
import { TableRequests } from "./components/TableRequests";
import MapOccurences from "./components/MapOccurences";
import MapTracking from "./components/MapTracking";
import api from "../../services/api";

import { Helmet } from "react-helmet";
import utils from "../../utils";
import { calculateDistance } from "../../utils/maps";

interface LocationProps {
  id: string;
  accurracy: string;
  altitude: string;
  latitude: number;
  longitude: number;
}

interface VehicleProps {
  id: string;
  vehicle: string;
  color: string;
  plate: string;
  type: string;
  interface: string;
}

interface BaseProps {
  id: string;
  base: string;
  outpost: string;
}

interface LocationProps {
  id: string;
  accuracy: number;
  altitude: number;
  latitude: number;
  longitude: number;
}

interface AddressProps {
  address: string;
  burgh: string;
  city: string;
  state: string;
  latitude: number;
  longitude: number;
  ResponsibleBase: BaseProps;
}

interface DurationProps {
  text: string;
  value: number;
}

interface OccurrenceProps {
  Occurrence: {
    id: string;
    name: string;
    code: string;
    type: string;
    status: string;
    additional_info: string;
    Base?: BaseProps;
    Location: LocationProps;
    created_at: string;
    updated_at: string;
  };
  Resident: {
    id_user: string;
    name: string;
    email: string;
    phone: string;
    // Base: BaseProps;
    Vehicle: VehicleProps[];
  };
  Employee?: {
    id: string;
    id_user: string;
    status: string;
    type: string;
    name: string;
    email: string;
    phone: string;
    Vehicle: VehicleProps[];
  };
  Vehicle?: VehicleProps;
  Address?: AddressProps;
  durationLocation: DurationProps;
}

interface ISecurityInfo {
  id: string;
  name: string;
  distance: string;
  alert: string;
  status: string;
}

export const LatestRequests = (placeholder = "Digite suas observações aqui...") => {
  const {
    occurrencesList,
    costumersList,
    getCostumersList,
    getAllOccurrences,
    getSecuritiesList,
    securitiesList,
    triggerSecurity,
    setOccurrencesList,
    triggerSecuritySuccess,
    handleFilters,
    filter,
    setFilter,
  } = useContext(ContextLatestRequests);

  const hours = Array.from({ length: 48 }, (_, index) => {
    const totalMinutes = index * 30;
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const id = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
    return {
      id,
      value: `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`,
    };
  });

  const [isOccurrenceSidetabOpen, setIsOccurrenceSidetabOpen] = useState(false)
  const [occurrence, setOccurrence] = useState<OccurrenceProps>()
  const [observations, setObservations] = useState('')

  const [occurrenceUserDetails, setOccurrenceUserDetails] = useState()
  const [isOccurrenceUserSidetabOpen, setIsOccurrenceUserSidetabOpen] =
    useState(false);
  const [isSecuritySidetabOpen, setIsSecuritySideTabOpen] = useState(false)
  const [securityRedirect, setSecurityRedirect] = useState(false)
  const [isModalSecurityRedirectOpen, setIsModalSecurityRedirect] = useState(false);
  const [isModalObservationOpen, setIsModalObservation] = useState(false);

  const [selectedSecurityId, setSelectSecurityId] = useState("")
  const [selectedSecurity, setSelectSecurity] = useState<ISecurityInfo>()

  const [baseMarkers, setBaseMarkers] = useState([])
  const [userMarkers, setUserMarkers] = useState([])
  const [employeeMarkers, setEmployeeMarkers] = useState([])

  const [timeDuration, setTimeDuration] = useState<any>();

  const handleCheckbox = (id) => {
    setSelectSecurityId(id);
    const security = securitiesList.find((item) => item.id === id)
    setSelectSecurity(security);
  };

  const handleState = (setValue) => {
    setValue((prev) => !prev)
  };

  const getMapMarkers = () => {
    api.get("/v1/dashboard/surveillance/markers").then((response) => {
      const data = response.data
      setBaseMarkers(data.bases)
      setUserMarkers(data.users)
      setEmployeeMarkers(data.employees)
    });
  };

  const callFilteredOccurrences = (filters) => {
    // console.log("🚀 ~ callFilteredOccurrences ~ filters:", filters)
    if (filters?.status === "") delete filters.status
    if (filters?.customer === "") delete filters.customer
    if (filters?.start_date === "") delete filters.start_date
    if (filters?.end_date === "") delete filters.end_date
    if (filters?.start_hour === "") delete filters.start_hour
    api
      .post("/v1/dashboard/surveillance/occurrences", filters)
      .then((response) => {
        if (response && response.data) {
          // console.log(response.data)
          // console.log(filters)
          setOccurrencesList(response.data)
        }
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      });
  };

  const endOccurrenceHandler = () => {
    setTimeout(() => {
      api
        .put('/v1/app/security/occurrences/update', {
          id: occurrence?.Occurrence.id,
          id_employee: occurrence?.Employee?.id,
          status: 'FECHADO',
          additional_info: observations

        })
        .then(async (res) => {
          // console.log('FOIIII')
          // console.log("iddd", occurrence?.Occurrence.id)
          setIsModalObservation(true)
        })
        .catch((err) => {
          console.log("errooooo", err.response.data);
          // console.log("iddd", occurrence?.Occurrence.id)
          // console.log("employee iddd", occurrence?.Employee?.id)
        });
    }, 2000);
  };

  // resolver essa merda
  useEffect(() => {
    if (!occurrence?.Occurrence.id) return; // Aguarda occurrence ser preenchido

    const fetchOcurrenceDuration = async () => {
      try {
        const response = await api.post('/v1/dashboard/surveillance/tracking', {
          occurrenceId: occurrence.Occurrence.id,
        });

        // console.log('DETALHE DA OCORRÊNCIA DADOS:', response.data);
        // console.log('Duração de tempo:', response.data.durationLocation.text);
        setTimeDuration(response.data.durationLocation.text);
      } catch (error) {
        console.error('Erro na requisição ou cálculo:', error);
      }
    };

    fetchOcurrenceDuration();
  }, [occurrence])

  useEffect(() => {
    getMapMarkers()
    getCostumersList()
    callFilteredOccurrences(filter)

    // const getMapMarkersInterval = setInterval(() => {
    //   getMapMarkers()
    // }, 10000)

    const getCostumersListInterval = setInterval(() => {
      getCostumersList();
    }, 10000);

    // const callFilteredOccurrencesInterval = setInterval(() => {
    //   callFilteredOccurrences(filter);
    // }, 10000);

    return () => {
      // clearInterval(getMapMarkersInterval)
      clearInterval(getCostumersListInterval)
      // clearInterval(callFilteredOccurrencesInterval);
    };
  }, [])

  const handleObservationChange = (event) => {
    setObservations(event.target.value);
  };


  useEffect(() => {

    const callFilteredOccurrencesInterval = setInterval(() => {
      callFilteredOccurrences(filter);
    }, 10000)
    return () => {
      // clearInterval(getMapMarkersInterval)
      clearInterval(callFilteredOccurrencesInterval)
    }
  }, [costumersList])

  return (
    <>
      <Helmet>
        <title>Previx - Últimas ocorrências</title>
        <meta
          name="Previx - Últimas ocorrências"
          content="Página de últimas ocorrências"
        />
      </Helmet>

      <DefaultContent
        icon={<Siren size={26} color="#003E5F" />}
        title="Vigilância - Últimas ocorrências"
      >
        <Container>
          <Title>Mapa indicando localidade das ocorrências</Title>
          <Box padding="0">
            <MapOccurences
              baseLocationData={baseMarkers}
              userLocationData={userMarkers}
              employeeLocationData={employeeMarkers}
              setOccurrenceUserDetails={setOccurrenceUserDetails}
              openDetails={setIsOccurrenceUserSidetabOpen}
            />
          </Box>
          <Box>
            <LabelsContainer>
              <Title>Legenda:</Title>
              <Labels color="#003E5F">
                Sede da Previx
                <img src={PrevixIcon} alt="Previx Icon" />
              </Labels>
              <Labels color="#B00">
                {" "}
                <LabelBullet color="#B00" /> Usuários
              </Labels>
              <Labels color="#067FB7">
                <LabelBullet color="#067FB7" />
                Funcionários
              </Labels>
            </LabelsContainer>
          </Box>
          <Box>
            <FiltersContainer>
              <Title>Filtros de busca:</Title>
              <Select
                flex="1"
                onchange={
                  (e) => handleFilters("customer", e.target.value)
                  // setFilter((prev) => ({
                  //   ...prev,
                  //   customer: e.target.value,
                  // }))
                }
                label={{
                  title: "Clientes",
                  htmlFor: "",
                  color: "",
                  fontSize: "12px",
                }}
                data={costumersList}
                padding="0.375rem 0.625rem"
                backgroundcolor=""
                bordercolor="#CECECE"
                currentOption={filter.customer}
                outlinecolor=""
              />
              <Input.Root>
                <Input.Label
                  title="Data"
                  htmlFor="latestRequestfilterClients"
                />
                <Input.Wrapper
                  borderColor="#CECECE"
                  backgroundColor="#F7F7F7"
                  outlineColor=""
                >
                  <Input.Content
                    id="latestRequestfilterClients"
                    padding="0.375rem 0.625rem"
                    onChange={(e) => {
                      handleFilters("start_date", e.target.value)
                      handleFilters("end_date", e.target.value)
                    }}
                    // onChange={(e) =>
                    //   setFilter((prev) => ({
                    //     ...prev,
                    //     start_date: e.target.value,
                    //   }))
                    // }
                    type="date"
                    value={filter.start_date}
                    placeholder="Pesquisar"
                  />
                </Input.Wrapper>
              </Input.Root>
              <Select
                flex="1"
                onchange={(e) =>
                  setFilter((prev) => ({
                    ...prev,
                    start_hour: e.target.value,
                  }))
                }
                label={{
                  title: "Hora início",
                  htmlFor: "",
                  color: "",
                  fontSize: "12px",
                }}
                data={hours}
                padding="0.375rem 0.625rem"
                backgroundcolor=""
                bordercolor="#CECECE"
                currentOption={filter.start_hour}
                outlinecolor=""
              />
              <Select
                flex="1"
                onchange={
                  (e) => handleFilters("end_hour", e.target.value)
                  // setFilter((prev) => ({
                  //   ...prev,
                  //   end_hour: e.target.value
                  // }))
                }
                label={{
                  title: "Hora fim",
                  htmlFor: "",
                  color: "",
                  fontSize: "12px",
                }}
                data={hours}
                padding="0.375rem 0.625rem"
                backgroundcolor=""
                bordercolor="#CECECE"
                currentOption={filter.end_hour}
                outlinecolor=""
              />
              <ButtonContainer>
                <Button.Root
                  type="button"
                  backgroundColor="#003E5F"
                  onClick={() => {
                    callFilteredOccurrences(filter)
                  }}
                  padding=".6rem"
                >
                  <Button.Content title="Buscar" fontSize="12px" />
                </Button.Root>
              </ButtonContainer>
            </FiltersContainer>
          </Box>
          <Title>
            Listando{" "}
            {occurrencesList?.length !== 0 ? occurrencesList?.length : "0"}{" "}
            ocorrências (todas ocorrências){" "}
          </Title>
          <Box>
            <TableRequests
              data={occurrencesList}
              getOccurrence={setOccurrence}
              openDetails={() => {
                handleState(setIsOccurrenceSidetabOpen)
              }}
            />
          </Box>

          {occurrence ? (
            <SideTab
              open={isOccurrenceSidetabOpen}
              width="40%"
              title={
                "#" +
                occurrence.Occurrence.code +
                " - Ocorrência de " +
                occurrence.Occurrence.type
              }
              toggleFunction={() => handleState(setIsOccurrenceSidetabOpen)}
            >
              <Input.Root>
                <Input.Label title="Quem solicitou:" htmlFor="occurrenceName" />
                <Input.Wrapper>
                  <Input.Content
                    id="occurrenceName"
                    type="text"
                    value={occurrence.Resident.name}
                    readOnly
                  />
                </Input.Wrapper>
              </Input.Root>
              <Row>
                <Input.Root flex="1">
                  <Input.Label title="Horário de envio:" htmlFor="" />
                  <Input.Wrapper>
                    <Input.Content
                      id=""
                      type="text"
                      value={new Date(
                        occurrence.Occurrence.created_at
                      ).toLocaleString()}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label title="Modalidade:" htmlFor="" />
                  <Input.Wrapper>
                    <Input.Content
                      id=""
                      type="text"
                      value={occurrence.Occurrence.type}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
                {occurrence.Occurrence.type !== "Pânico" && (
                  <>
                    <Input.Root flex="1">
                      <Input.Label title="Posto:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrence.Occurrence.Base?.outpost}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </>)}
              </Row>
              <Input.Root>
                <Input.Label title="Quem está atuando no caso:" htmlFor="" />
                <Input.Wrapper>
                  <Input.Content
                    id=""
                    type="text"
                    value={occurrence.Employee ? occurrence.Employee.name : "-"}
                    readOnly
                  />
                </Input.Wrapper>
              </Input.Root>
              <TitleLine title="Objetivo da ocorrência" />
              <Input.Root>
                <Input.Wrapper>
                  <Input.Content
                    id=""
                    type="text"
                    value={occurrence.Occurrence.type}
                    readOnly
                  />
                </Input.Wrapper>
              </Input.Root>
              {occurrence.Occurrence.type !== "Pânico" && (
                <>
                  <TitleLine title="Identificação do usuário" />
                  <Row>
                    <Input.Root flex="1">
                      <Input.Label title="Veículo do usuário:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrence.Vehicle?.vehicle}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label title="Cor do carro:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrence.Vehicle?.color}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label title="Placa:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrence.Vehicle.plate}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                </>)}
              {(occurrence.Occurrence.type === "Escolta" || occurrence.Occurrence.type === "Pânico") && (
                <>
                  <TitleLine title="Mapa do percurso em tempo real" />
                  <Box padding="0">
                    <MapTracking occurrence={occurrence} />
                  </Box>
                </>
              )}
              {(occurrence.Occurrence.type === "Suspeita") && (
                <>
                  <TitleLine title="Observações" />
                  <BoxText padding="0" value={observations} onChange={handleObservationChange} placeholder={'Digite suas observações aqui ...'}>

                  </BoxText>

                  <ButtonContainer>
                    <Button.Root
                      type="button"
                      backgroundColor="#0079B1"
                      onClick={() => {
                        endOccurrenceHandler();

                      }}
                    >
                      <Button.Content
                        title="Finalizar Ocorrência"
                        fontSize="12px"
                      />
                    </Button.Root>
                  </ButtonContainer>
                </>
              )}

              {occurrence.Employee &&
                occurrence.Occurrence.status === "Em ocorrência" ? (
                <>
                  <Row>
                    <Input.Root flex="1">
                      <Input.Label title="Segurança:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrence.Employee.name}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label title="Veículo:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrence.Employee.Vehicle[0].vehicle}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label title="Placa:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrence.Employee.Vehicle[0].plate}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                  <Row>
                    <Input.Root flex="2">
                      <Input.Label title="Ação do momento:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={"Escoltando até a residência"}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Tempo previsto de chegada"
                        htmlFor=""
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={timeDuration}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                </>
              ) : (
                <>
                  {occurrence.Occurrence.type === "Escolta" &&
                    occurrence.Occurrence.status === "Aguardando ação" && (
                      <ButtonContainer>
                        <Button.Root
                          type="button"
                          backgroundColor="#0079B1"
                          onClick={() => {
                            handleState(setIsSecuritySideTabOpen);
                            getSecuritiesList(
                              occurrence.Occurrence.id,
                              occurrence.Occurrence.Base.id
                            );
                          }}
                        >
                          <Button.Content
                            title="Acionar um segurança"
                            fontSize="12px"
                          />
                        </Button.Root>
                      </ButtonContainer>
                    )}
                </>
              )}
            </SideTab>
          ) : null}

          {occurrenceUserDetails ? (
            <SideTab
              open={isOccurrenceUserSidetabOpen}
              width="40%"
              title={
                "#" +
                occurrenceUserDetails.code +
                " - Ocorrência de " +
                occurrenceUserDetails.type
              }
              toggleFunction={() => handleState(setIsOccurrenceUserSidetabOpen)}
            >
              <Input.Root>
                <Input.Label title="Quem solicitou:" htmlFor="occurrenceName" />
                <Input.Wrapper>
                  <Input.Content
                    id="occurrenceName"
                    type="text"
                    value={occurrenceUserDetails.name}
                    readOnly
                  />
                </Input.Wrapper>
              </Input.Root>
              <Row>
                <Input.Root flex="1">
                  <Input.Label title="Horário de envio:" htmlFor="" />
                  <Input.Wrapper>
                    <Input.Content
                      id=""
                      type="text"
                      value={new Date(
                        occurrenceUserDetails.created_at
                      ).toLocaleDateString()}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label title="Modalidade:" htmlFor="" />
                  <Input.Wrapper>
                    <Input.Content
                      id=""
                      type="text"
                      value={occurrenceUserDetails.type}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label title="Posto:" htmlFor="" />
                  <Input.Wrapper>
                    <Input.Content
                      id=""
                      type="text"
                      value={occurrenceUserDetails.code}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
              </Row>
              <Input.Root>
                <Input.Label title="Quem está atuando no caso:" htmlFor="" />
                <Input.Wrapper>
                  <Input.Content
                    id=""
                    type="text"
                    value={occurrenceUserDetails.name}
                    readOnly
                  />
                </Input.Wrapper>
              </Input.Root>
              <TitleLine title="Objetivo da ocorrência" />
              <Input.Root>
                <Input.Wrapper>
                  <Input.Content
                    id=""
                    type="text"
                    value={occurrenceUserDetails.name}
                    readOnly
                  />
                </Input.Wrapper>
              </Input.Root>
              <TitleLine title="Identificação do usuário" />
              <Row>
                <Input.Root flex="1">
                  <Input.Label title="Veículo do usuário:" htmlFor="" />
                  <Input.Wrapper>
                    <Input.Content
                      id=""
                      type="text"
                      value={occurrenceUserDetails.created_at}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label title="Cor do carro:" htmlFor="" />
                  <Input.Wrapper>
                    <Input.Content
                      id=""
                      type="text"
                      value={occurrenceUserDetails.type}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
                <Input.Root flex="1">
                  <Input.Label title="Placa:" htmlFor="" />
                  <Input.Wrapper>
                    <Input.Content
                      id=""
                      type="text"
                      value={occurrenceUserDetails.code}
                      readOnly
                    />
                  </Input.Wrapper>
                </Input.Root>
              </Row>
              <TitleLine title="Mapa do percurso em tempo real" />
              <Box padding="0">
                <MapTracking
                  startPoint={[-46.61582734898114, -23.720824896150084]}
                  endPoint={[-46.66195828735507, -23.554504624999677]}
                />
              </Box>

              {securityRedirect ? (
                <>
                  <Row>
                    <Input.Root flex="1">
                      <Input.Label title="Segurança:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrenceUserDetails.Occurrence.created_at}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label title="Veículo:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrenceUserDetails.Occurrence.type}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label title="Placa:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrenceUserDetails.Occurrence.code}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                  <Row>
                    <Input.Root flex="2">
                      <Input.Label title="Ação do momento:" htmlFor="" />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrenceUserDetails.Occurrence.created_at}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Tempo previsto de chegada"
                        htmlFor=""
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id=""
                          type="text"
                          value={occurrenceUserDetails.Occurrence.type}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                </>
              ) : (
                <ButtonContainer>
                  <Button.Root
                    type="button"
                    backgroundColor="#0079B1"
                    onClick={() => {
                      handleState(setIsSecuritySideTabOpen);
                      getSecuritiesList(
                        occurrenceUserDetails.Occurrence.id,
                        occurrenceUserDetails.Resident.Base.id
                      );
                    }}
                  >
                    <Button.Content
                      title="Acionar um segurança"
                      fontSize="12px"
                    />
                  </Button.Root>
                </ButtonContainer>
              )}
            </SideTab>
          ) : null}

          {
            <SideTab
              open={isSecuritySidetabOpen}
              width="40%"
              title={"Acionar um segurança"}
              toggleFunction={() => {
                handleState(setIsSecuritySideTabOpen);
                setSelectSecurity(undefined);
                setSelectSecurityId("");
              }}
            >
              <Title>Selecionar um segurança para a ação:</Title>
              <Table>
                <thead>
                  <tr>
                    <TableHeader></TableHeader>
                    <TableHeader>Nome de usuário</TableHeader>
                    <TableHeader>Distância da ocor.</TableHeader>
                    <TableHeader>Sempre alerta</TableHeader>
                    <TableHeader>Status</TableHeader>
                  </tr>
                </thead>
                <tbody>
                  {!securitiesList ? (
                    <tr>
                      <TableCellEmpty colSpan={8}>
                        Nenhum dado encontrado
                      </TableCellEmpty>
                    </tr>
                  ) : (
                    securitiesList?.map((val) => {
                      return (
                        <tr key={val.id}>
                          <TableCell>
                            <CheckboxContainer
                              onClick={() => handleCheckbox(val.id)}
                            >
                              <CheckboxInput
                                checked={selectedSecurityId === val.id}
                                onChange={() => handleCheckbox(val.id)}
                                data-id={val.id}
                              />
                              <CheckboxAppearence
                                isChecked={selectedSecurityId === val.id}
                              >
                                <Check size={36} />
                              </CheckboxAppearence>
                            </CheckboxContainer>
                          </TableCell>
                          <TableCell>{val.Userinfo.name}</TableCell>
                          <TableCell>
                            {val.OccurrenceDistance.distance.text}
                          </TableCell>
                          <TableCell>{val.AlwaysAlert}</TableCell>
                          <TableCell>
                            {val.online === "Online" ? (
                              <StatusBox status={val.status}>Online</StatusBox>
                            ) : (
                              <StatusBox status={val.status}>Offline</StatusBox>
                            )}
                          </TableCell>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </Table>
              {selectedSecurityId.length > 0 && selectedSecurity ? (
                <>
                  <Title>Informações do segurança</Title>
                  <Row>
                    <Input.Root flex="2">
                      <Input.Label title="Nome:" htmlFor="securityInfoName" />
                      <Input.Wrapper>
                        <Input.Content
                          id="securityInfoName"
                          type="text"
                          value={selectedSecurity.Userinfo.name}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Sempre alerta"
                        htmlFor="securityInfoAlwaysAlert"
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id="securityInfoAlwaysAlert"
                          type="text"
                          value={selectedSecurity.AlwaysAlert}
                          readOnly
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                  <Row>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Tipo de veículo"
                        htmlFor="securityInfoVehicleType"
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id="securityInfoVehicleType"
                          type="text"
                          value={selectedSecurity.Userinfo.Vehicle[0].type}
                          readOnly
                          disabled
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="2">
                      <Input.Label
                        title="Veículo"
                        htmlFor="securityInfoVehicle"
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id="securityInfoVehicle"
                          type="text"
                          value={selectedSecurity.Userinfo.Vehicle[0].vehicle}
                          readOnly
                          disabled
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label title="Placa" htmlFor="securityInfoPlate" />
                      <Input.Wrapper>
                        <Input.Content
                          id="securityInfoPlate"
                          type="text"
                          value={selectedSecurity.Userinfo.Vehicle[0].plate}
                          readOnly
                          disabled
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                  <Row>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Distância até o usuário"
                        htmlFor="securityInfoDistance"
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id="securityInfoDistance"
                          type="text"
                          value={selectedSecurity.UserDistance.distance.text}
                          readOnly
                          disabled
                        />
                      </Input.Wrapper>
                    </Input.Root>
                    <Input.Root flex="1">
                      <Input.Label
                        title="Tempo previsto de chegada"
                        htmlFor="securityInfoTimeToArrive"
                      />
                      <Input.Wrapper>
                        <Input.Content
                          id="securityInfoTimeToArrive"
                          type="text"
                          value={selectedSecurity.UserDistance.duration.text}
                          readOnly
                          disabled
                        />
                      </Input.Wrapper>
                    </Input.Root>
                  </Row>
                  <ButtonContainer>
                    <Button.Root
                      type="button"
                      backgroundColor="#0079B1"
                      onClick={() => {
                        triggerSecurity(
                          occurrence,
                          selectedSecurity.Employee.id
                        );
                        setIsModalSecurityRedirect(true);
                      }}
                    >
                      <Button.Content
                        title="Acionar este segurança"
                        fontSize="12px"
                      />
                    </Button.Root>
                  </ButtonContainer>
                </>
              ) : null}
            </SideTab>
          }
          <Modal.Root
            backgroundcolor="#fff"
            borderradius="6px"
            width="30%"
            height="fit-content"
            left="50%"
            top="50%"
            open={isModalSecurityRedirectOpen}
            setIsOpenController={() => {
              location.reload();
            }}
            padding="0 0 1rem 0"
          >
            <Modal.Header onclick={() => location.reload()} />
            <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
            <Modal.Content
              value="Segurança redirecionado!"
              subvalue="As informações e ações foram passadas
            para o aplicativo do segurança e informamos
            também o usuário com uma atualização no caso."
            />
            <Modal.Footer>
              <Button.Root
                type="button"
                backgroundColor="#00517D"
                onClick={() => {
                  handleState(setIsModalSecurityRedirect);
                  handleState(setIsSecuritySideTabOpen);
                  handleState(setSecurityRedirect);
                  location.reload();
                }}
              >
                <Button.Content title="Voltar para página" fontSize="12px" />
              </Button.Root>
            </Modal.Footer>
          </Modal.Root>
          <Modal.Root
            backgroundcolor="#fff"
            borderradius="6px"
            width="30%"
            height="fit-content"
            left="50%"
            top="50%"
            open={isModalObservationOpen}
            setIsOpenController={() => {
              location.reload();
            }}
            padding="0 0 1rem 0"
          >
            <Modal.Header onclick={() => location.reload()} />
            <Modal.Icon icon={<CheckCircle size={48} fill="#006598" />} />
            <Modal.Content
              value="Ocorrência finalziada!"

            />
            <Modal.Footer>
              <Button.Root
                type="button"
                backgroundColor="#00517D"
                onClick={() => {
                  handleState(setIsModalObservation);
                  location.reload();
                }}
              >
                <Button.Content title="Voltar para página" fontSize="12px" />
              </Button.Root>
            </Modal.Footer>
          </Modal.Root>
        </Container>
      </DefaultContent>
    </>
  );
};
